// <div data-controller="components--auth">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";
import { t } from "@/utils/i18n";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
    static targets = ["form", "email", "pin", "marketingAgreement", "confirmButtons", "authenticationField", "privacyAgreement", "authButton", "pinNotification"];
    static classes = [""]
    static values = {};

    initialize() {
        this.pinSent = false;
    }

    startAuthentication(e) {
        if (!this.emailTarget.checkValidity()) {
            this.emailTarget.focus();
            return false;
        }

        if (this.hasPrivacyAgreementTarget) {
            if (!this.privacyAgreementTarget.checkValidity()) {
                this.privacyAgreementTarget.focus();
                return false;
            }
        }

        const button = e?.currentTarget;
        const originalButtonHtml = button?.innerHTML;
        if (button) {
            button.disabled = true;
            button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="animate-spin h-5 w-5 mx-auto" viewBox="0 0 24 24" fill="currentColor"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="12" y1="6" x2="12" y2="3" stroke="currentColor" stroke-width="2"/><line x1="6" y1="12" x2="3" y2="12" stroke="currentColor" stroke-width="2"/><line x1="7.75" y1="7.75" x2="5.6" y2="5.6" stroke="currentColor" stroke-width="2"/></svg>';
        }

        this.emailTarget.readOnly = true;
        api.post("/api/users/send_pin", {email: this.emailTarget.value}).then((res) => {
            if (res.status === 200) {
                this.pinSent = true;
                if (this.hasAuthButtonTarget) {
                    this.authButtonTarget.classList.add("hidden");
                    this.emailTarget.classList.remove("rounded-none", "rounded-l-md", "border-r-0");
                    this.emailTarget.classList.add("rounded-md");
                }
                this.authenticationFieldTarget.classList.remove("hidden");
                this.pinTarget.focus();
                // 소비자 Outlook 은 인증코드가 정크함으로 분류될 수 있어 PIN 입력칸 아래에 스팸함 확인을 안내한다.
                if (res.data?.check_spam && this.hasPinNotificationTarget) {
                    this.pinNotificationTarget.innerHTML = t(
                        "pin.enter_pin_with_spam_notice_html",
                        '이메일로 전송 된 8자리 숫자를 입력해주세요<br><span class="text-blue-600 dark:text-blue-400">📩 Outlook은 정크/스팸함도 꼭 확인해주세요.</span>'
                    );
                }
            } else {
                this.emailTarget.readOnly = false;
                if (button) {
                    button.disabled = false;
                    button.innerHTML = originalButtonHtml;
                }
                alert(res.data.msg);
            }
        }).catch((err) => {
            this.emailTarget.readOnly = false;
            if (button) {
                button.disabled = false;
                button.innerHTML = originalButtonHtml;
            }
            alert(err.response?.data?.msg || t("pin.generic_error", "오류가 발생했습니다."));
        })
    }

    resendPin(e) {
        e.target.classList.remove("text-green-700");
        e.target.classList.add("text-yellow-500");
        e.target.innerText = t("pin.sending", "발송중..");
        api.post("/api/users/send_pin", {email: this.emailTarget.value}).then((res) => {
            if (res.status === 200) {
                this.pinSent = true;
                e.target.classList.remove("text-yellow-500", "cursor-pointer");
                e.target.classList.add("text-green-700");
                e.target.innerText = t("pin.resent", "재발송완료 (스팸함도 확인해주세요)");
                e.target.dataset.action = null;
                this.authenticationFieldTarget.classList.remove("hidden");
            } else {
                e.target.classList.remove("text-yellow-700");
                e.target.classList.add("text-red-700");
                e.target.innerText = res.data.msg || t("pin.failed", "발송실패 (재시도 하기)");
                this.confirmButtonsTarget.style.removeProperty("display");
            }
        })
    }

    connect() {
        this.formTarget.addEventListener("keydown", (e) => {
            const keyCode = e.keyCode || e.which;

            if (keyCode === 13 && !this.pinSent) {
                e.preventDefault();
                this.startAuthentication();
                return false;
            }
        })
    }

    disconnect() {

    }
}